import { EntityWidget } from "./EntityWidget";
import { ArrangementObjectEntityController } from "../ArrangementEntityController";
import { ArrangementGroup } from "@rhinov/savane-js";

 export class ArrangementGroupEntityWidget extends EntityWidget{
    declare entity: ArrangementGroup;

    constructor(entity: ArrangementGroup, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
        this.propertiesTab = ['childList', 'plusLess', 'buttonToggle', 'blameLayout'];
        this.controller = new ArrangementObjectEntityController(entity , panel, deliverable, null, undefined as any);
        this.controller.propertiesTab = this.propertiesTab;
    }

    html(callback: CallableFunction) {
        var i;
        this.controller.setupchildList(() => {
            var html = this.nameHeader() + this.propertyStart();
            for (i = 0; i < this.propertiesTab.length; i++) {
                html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
            }
            html += this.propertyEnd();
            return callback(html);
        });
    }
}